import { SearchErpVesselResult } from "../Models/Lookup/SearchErpVesselResult";
import { SearchErpVesselRequest } from "../Models/Lookup/SearchErpVesselRequest";
import { SearchErpCustomerRequest } from "../Models/Lookup/SearchErpCustomerRequest";
import { SearchErpCustomerResult } from "../Models/Lookup/SearchErpCustomerResult";

export class LookupDataService {
    public static removeUoMCrossReference(entityId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/lookup/crossreferences/uom/${entityId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }    

    public static removeVesselCrossReference(entityId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/lookup/crossreferences/vessel/${entityId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    } 

    public static removeCustomerCrossReference(entityId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/lookup/crossreferences/customer/${entityId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    } 

    public static removeDepartmentCrossReference(entityId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/lookup/crossreferences/department/${entityId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    } 
    
    public static searchVessel(vesselName: string, callback: (output: SearchErpVesselResult | undefined) => void, error?: () => void) {
        var model = new SearchErpVesselRequest();
        model.vesselName = vesselName;

        $.ajax({
            type: 'POST',
            url: `/api/company/lookup/searchvessel`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            data: JSON.stringify(model),
            error: () => {
                error && error();
            }
        });
    }

    public static searchCustomer(customerName: string, callback: (output: SearchErpCustomerResult | undefined) => void, error?: () => void) {
        var model = new SearchErpCustomerRequest();
        model.customerName = customerName;

        $.ajax({
            type: 'POST',
            url: `/api/company/lookup/searchcustomer`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            data: JSON.stringify(model),
            error: () => {
                error && error();
            }
        });
    }

    public static removeErpVessel(entityId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/lookup/erp/vessel/${entityId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    } 

        public static removeCustomerArticleCrossReference(erpCustomerId: string, articleCrossReferenceId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/lookup/customer/${erpCustomerId}/article-cross-references/${articleCrossReferenceId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    } 
}